<template>
  <b-breadcrumb v-if="fileDetails">
    <b-breadcrumb-item :to="{path: '/', query: {platformId: fileDetails.platform.id}}">
      <span>{{ fileDetails.platform.name }}</span>
    </b-breadcrumb-item>
    <b-breadcrumb-item :to="{path: '/', query: {platformId: fileDetails.platform.id, majorId: fileDetails.major.id}}">
      <span>{{ fileDetails.major.version }}</span>
    </b-breadcrumb-item>
    <b-breadcrumb-item
      v-if="fileDetails.minor.version"
      :to="{path: '/', query: {platformId: fileDetails.platform.id, majorId: fileDetails.major.id, minorId: fileDetails.minor.id}}">
      <span>{{ fileDetails.minor.version }}</span>
    </b-breadcrumb-item>
    <li
      class="breadcrumb-item active"
      aria-current="page">
      <span>{{ fileName }}</span>
    </li>
  </b-breadcrumb>
</template>

<script>
  export default {
    name: "FileBreadcrumb",
    props: {
      fileName: {
        type: String,
        required: true,
      },
      fileDetails: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style scoped>

</style>